import { render } from "./SpendEvolutionVsPrevPeriod.vue?vue&type=template&id=cb61fd3a&scoped=true"
import script from "./SpendEvolutionVsPrevPeriod.vue?vue&type=script&lang=js"
export * from "./SpendEvolutionVsPrevPeriod.vue?vue&type=script&lang=js"

import "./SpendEvolutionVsPrevPeriod.vue?vue&type=style&index=0&id=cb61fd3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb61fd3a"]])

export default __exports__